import { atom } from "jotai";

export const optionsAtom = atom({
  sk: [
    { id: "30", title: "PREMIOVÉ Bývanie", iconClass: "domyIcon", item: "homeItem" }, //HHI
    { id: "34", title: "PREMIOVÉ Podnikanie", iconClass: "businessIcon", item: "businessItem" }, //SME
    { id: "32", title: "PREMIOVÉ Bytové domy", iconClass: "bytyIcon", item: "buildingsItem" }, //RBI
    { id: "29", title: "Firemní klienti", iconClass: "companyIcon", item: "companyItem" },
    { id: "26", title: "Všeobecné otázky", iconClass: "faqIcon", item: "faqItem" },
  ],
  cz: [
    // { id: "28", title: "PREMIOVÉ Bydlení", iconClass: "domyIcon", item: "homeItem" },//HHI
    { id: "33", title: "PREMIOVÉ Podnikání", iconClass: "businessIcon", item: "businessItem" },//SME
    // { id: "31", title: "PREMIOVÉ Obytné domy", iconClass: "bytyIcon", item: "buildingsItem" },//RBI
    { id: "27", title: "Firemní klienti", iconClass: "companyIcon", item: "companyItem" },
    { id: "25", title: "Obecné otázky", iconClass: "faqIcon", item: "faqItem" },
  ]
});
